import { Leg } from '@approot/models';
import { getAllAttributeOptions } from './leg-attribute-utilities';
import { optionsChangeHandler } from './leg.utilities';
import { FormGroup } from '@angular/forms';

export function koTypeChange(val: string, form: FormGroup, leg: Leg) {
  if (val === 'FullKnockOut' || val === 'KeepLastFlow') {
    // Set TP Adjustment if KO Type is FullKnockOut or KeepLastFlow, Otherwise keep Normal TP Adjustment Options
    optionsChangeHandler(
      form,
      leg,
      'targetProfitAdjustmentType',
      ['None'],
      'None'
    );
  } else {
    let tpAdjArr = [...getAllAttributeOptions('currency', leg)];
    optionsChangeHandler(
      form,
      leg,
      'targetProfitAdjustmentType',
      [
        'Adjust Strike',
        'Adjust Notional',
        'Cash (' + tpAdjArr[0] + ')',
        'Cash (' + tpAdjArr[1] + ')'
      ],
      ''
    );
  }
}
